import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { LogOut, Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";
import AdminProducts from "../components/admin/AdminProducts";
import AdminOrders from "../components/admin/AdminOrders";
import AdminRequests from "../components/admin/AdminRequests";
import AdminShipping from "../components/admin/AdminShipping";

const TABS = [
  { id: "orders", label: "Orders", Comp: AdminOrders },
  { id: "requests", label: "Custom Requests", Comp: AdminRequests },
  { id: "products", label: "Products", Comp: AdminProducts },
  { id: "shipping", label: "Shipping", Comp: AdminShipping },
];

export default function Admin() {
  const { user, logout } = useAuth();
  const [tab, setTab] = useState("orders");
  const [summary, setSummary] = useState(null);
  useEffect(() => { if (user) api.get("/admin/summary").then((r) => setSummary(r.data)); }, [user, tab]);

  if (user === null) return <div className="flex justify-center py-24"><Loader2 className="h-8 w-8 animate-spin text-[var(--pink)]" /></div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  const Active = TABS.find((t) => t.id === tab).Comp;

  return (
    <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6" data-testid="admin-dashboard">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div>
          <p className="font-script text-lg text-[var(--pink)]">Owner dashboard</p>
          <h1 className="text-4xl">Hi, L3's Kitchen!</h1>
        </div>
        <button onClick={logout} className="inline-flex items-center gap-2 rounded-full border border-white/20 px-4 py-2 text-sm font-bold hover:border-[var(--pink)]" data-testid="admin-logout-button"><LogOut className="h-4 w-4" /> Log out</button>
      </div>
      {summary && (
        <div className="mt-6 grid grid-cols-3 gap-3" data-testid="admin-summary">
          {[["New paid orders", summary.new_orders, "var(--pink)"], ["New requests", summary.new_requests, "var(--blue-soft)"], ["Products", summary.products, "#fff"]].map(([l, v, c]) => (
            <div key={l} className="panel p-4"><p className="font-display text-3xl" style={{ color: c }}>{v}</p><p className="text-xs font-bold text-white/60 sm:text-sm">{l}</p></div>
          ))}
        </div>
      )}
      <div className="mt-8 flex gap-2 overflow-x-auto border-b border-white/10 pb-px" data-testid="admin-tabs">
        {TABS.map((t) => (
          <button key={t.id} onClick={() => setTab(t.id)} data-testid={`admin-tab-${t.id}`}
            className={`whitespace-nowrap border-b-4 px-4 py-3 text-sm font-extrabold transition-colors ${tab === t.id ? "border-[var(--pink)] text-white" : "border-transparent text-white/55 hover:text-white"}`}>{t.label}</button>
        ))}
      </div>
      <div className="mt-6"><Active /></div>
    </div>
  );
}
